import React, { useEffect } from "react";
import PageShell from "../components/PageShell";
import { setMeta } from "../lib/seo";
import { SAMPLE_ITINERARIES } from "../data/sampleItineraries";

export default function SampleItineraries() {
  useEffect(() => {
    setMeta({
      title: "Sample Food Itineraries — Culinera",
      description:
        "Read full sample food itineraries built by Culinera — a 3-day Edmonton food weekend and a 4-day Calgary–Banff road trip. Free to read, no email or signup required.",
      canonical: "https://culinera.ca/sample-itineraries",
    });
  }, []);

  return (
    <PageShell testid="sample-itineraries-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Sample Itineraries</h1>
        <p className="text-lg text-gray-600 mb-10 max-w-2xl">
          Here's exactly what the Culinera planner produces. Read these in full — no email, no signup — then build
          your own from the homepage.
        </p>

        <div className="grid gap-6 sm:grid-cols-2">
          {SAMPLE_ITINERARIES.map((s) => (
            <a
              key={s.slug}
              href={`/sample-itineraries/${s.slug}`}
              data-testid={`sample-card-${s.slug}`}
              className="block border border-gray-200 rounded-2xl p-6 hover:border-teal-400 hover:shadow-md transition-all bg-white"
            >
              <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">{s.duration} · {s.city}</span>
              <h2 className="text-xl font-bold text-gray-900 mt-2 mb-2">{s.title}</h2>
              <p className="text-gray-600 text-sm">{s.intro}</p>
              <span className="inline-block mt-4 text-teal-600 font-semibold text-sm">Read the itinerary →</span>
            </a>
          ))}
        </div>

        <div className="mt-12">
          <a href="/?view=wizard" data-testid="samples-build-cta" className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors">Build your own itinerary</a>
        </div>
      </div>
    </PageShell>
  );
}
